<ng-container *ngIf="page && isLoaded">
  <div class="container">
    <c-page [page]="this.page"></c-page>

    <div class="p-2" *ngIf="isIstitutionalWebsite && isConadRoute">
      <h3 class="p-2">Agenzie Partner HeyConad Viaggi</h3>
        <div  #dynamicContainer id="conad-map"></div>
    </div>
    <div class="contacts-cta__container" *ngIf="showContactsLink">
      <a [routerLink]="'/contatti'" class="contacts-cta__button custom-btn btn btn--brand-color-03">
        Contattaci
      </a>
    </div>
  </div>
</ng-container>
